export const isOverlapping = (prodA, prodB, safetyMargin = 0) => {
    // OLD CODE
    // return (
    //     prodA.x < prodB.x + prodB.drawWidth &&
    //     prodA.x + prodA.drawWidth > prodB.x &&
    //     prodA.y < prodB.y + prodB.drawHeight &&
    //     prodA.y + prodA.drawHeight > prodB.y
    // );

    // NEW CODE
    const aLeft = prodA.x + safetyMargin
    const aRight = prodA.x + prodA.drawWidth - safetyMargin
    const aTop = prodA.y + safetyMargin
    const aBottom = prodA.y + prodA.drawHeight - safetyMargin

    const bLeft = prodB.x
    const bRight = prodB.x + prodB.drawWidth
    const bTop = prodB.y
    const bBottom = prodB.y + prodB.drawHeight

    const horizontalOverlap = bLeft < aRight && bRight > aLeft
    const verticalOverlap = bTop < aBottom && bBottom > aTop

    return horizontalOverlap && verticalOverlap
}

export const multipleProductOverlapChecking = (
    selectedProduct,
    otherProducts,
    safetyMargin
) => {
    // Check if the selected product overlaps with any of the other products
    for (let i = 0; i < otherProducts.length; i++) {
        const otherProduct = otherProducts[i]
        if (isOverlapping(selectedProduct, otherProduct, safetyMargin)) {
            return true // Overlap found
        }
    }
    return false // No overlap found
}

export function convertProductObjectInToNonSimulateProductObject(input) {

    return {
        productImage: [],
        recValue: input.recValue ?? null,
        isMvp: true,
        isOnTop: false,
        productTags: [],
        departmentName: input.department?.name ?? null,
        categoryName: input.category?.categoryName ?? null,
        subCategoryName:
            input.subCategoryName ??
            input.subcategory?.sub_category?.subCategoryName ??
            null,
        isBrandSetFromGS1: false,
        isSupplierSetFromGS1: false,
        fromProductLookup: false,
        snapId: -1,
        isStackable: input.isStackable ?? false,
        maxStackableCount: input.maxStackableCount ?? 0,
        mpId: null,
        departmentId: input.department?.departmentId ?? null,
        isHangable: input.isHangable ?? false,
        id: input.productId ?? null,
        imageUrl: input.imageUrl ?? null,
        notSimulatedReason: input.notSimulatedReason ?? 'custom',
        productId: input.productId ?? null,
        width: input.width ?? null,
        height: input.height ?? null,
        uom: input.uom ?? null,
        depth: input.depth ?? null,
        barcode: input.barcode ?? null,
        barcodeTwo: input.barcodeTwo ?? null,
        labelId: input.productLabel?.id ?? null,
        importBarcode: null,
        productSource: 'direct',
        gs1Code: '',
        posMappingId: null,
        lastPriceOfProduct: null,
        productName: input.productName ? input.productName : input.name ? input.name : null,
        name: input.productName ? input.productName : input.name ? input.name : null,
        isFavorite: false,
        isNOOS: true,
        isMandatory: false,
        isPremium: false,
        minQty: 0,
        maxQty: 0,
        minRevenue: 0,
        maxRevenue: 0,
        shelvesLife: 0,
        paceOfSalesInQty: 0,
        paceOfSalesInQtyUot: 'per_day',
        shelveLifeUot: 'days',
        revenueSource: null,
        sensitivity: 0,
        isManualAdded: true,
        productLabel: input.productLabel ?? null,
        brandName: input.brandName ?? input.productBrand?.brandName ?? null,
        brandId: input.brandId ?? input.productBrand?.brandId ?? null,
        subCategoryId:
            input.subCategoryId ??
            input.subcategory?.sub_category?.subCategoryId ??
            null,
        subCategoryColor: input.subcategory?.sub_category?.color ?? null,
        departmentColor: null,
        categoryColor: null,
        categoryId: input.category?.id ?? null,
        brandColor: input.productBrand?.color ?? null,
        supplierId: input.productBrand?.supplier?.supplierId ?? null,
        supplierName: input.productBrand?.supplier?.supplierName ?? null,
        supplierColor: null,
        completeStatus: 'FullData',
        mpUsageStatus: 'Old',
        importName: null,
        arigoName: null,
        gs1Name: null,
        importStatus: input.subcategory?.sub_category?.importStatus ?? 'None',
        isBlock: false,
        imageSource: 'Custom',
        hierarchyCompleteStatus: 'Completed',
        origin: 'Manual',
        dimensionSource: 'Custom',
        brandSource: 'Custom',
        chainOption: 'A',
        haggingHorizontal: input.haggingHorizontal ?? null,
        haggingVertical: input.haggingVertical ?? null,
        totalProfit: input.totalProfit ?? 0,
        sellPrice: input.sell_price ?? null,
        totalSale: input.totalSale ?? 0,
    }
}
